import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { CreateRole } from 'src/app/utils/interfaces/new/create-role.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Role } from 'src/app/utils/interfaces/new/role.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  private _wait = (ms) => new Promise(res => setTimeout(res, ms));

  constructor(
    private http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async create(roles: CreateRole): Promise<string> {
    try {
      const res = await this.http.post(`${environment.basePath}/hypermed/roles`, roles, this.httpOptions).toPromise();
      return '';
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async find(filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortOrder: SortEnum.ASC,
    sortBy: 'nom'
  }): Promise<Paginated<Role>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this.http.get(`${environment.basePath}/hypermed/roles`, this.httpOptions).toPromise();
      const roles = res.body as Role[];
      const paginated: Paginated<Role> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: roles
      };
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOne(id: string): Promise<Role> {
    try {
      const res = await this.http.get(`${environment.basePath}/hypermed/roles/${id}`, this.httpOptions).toPromise();
      const role = res.body as Role;
      return role;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async update(role: Role): Promise<void> {
    try {
      const res = await this.http.put(`${environment.basePath}/hypermed/roles/${role.id}`, role, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async delete(role: Role): Promise<void> {
    try {
      if (role.disabled) {
        role.disabled = false;
      } else {
        role.disabled = true;
      }
      const res = await this.http.put(`${environment.basePath}/hypermed/roles/${role.id}`, role, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async isRoleExists(roleName: string): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      try {
        const rolesPaginated = await this.find();
        const roles = rolesPaginated.objects;
        for (const role of roles) {
          if (role.nom === roleName) {
            resolve(true);
          }
        }
        resolve(false);
      } catch (e) {
        this._snack.openSnackBar(e.error.message);
        reject(e);
      }
    });
  }
}
